import { formatMoney } from 'accounting';

function chopPennies(string) {
  if (string.endsWith('.00')) {
    return string.substr(0, string.length - 3);
  } else {
    return string;
  }
}

export function formatProductPrice(price, currency) {
  return chopPennies(formatMoney(price, currency));
}



// WEBPACK FOOTER //
// ../src/client/utils/money.js